export default function Spinner() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="32px" height="32px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
      <path d="M5 50A45 45 0 0 0 95 50A45 48.5 0 0 1 5 50" fill="#566150" stroke="none">
        <animateTransform attributeName="transform" type="rotate" dur="2s" repeatCount="indefinite" keyTimes="0;1" values="0 50 51.75;360 50 51.75"></animateTransform>
      </path>
    </svg>
  )
}
